import React, { Fragment, useState, useReducer } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { useRouter } from 'next/router';

import passwordResetReducer, {
  initialPasswordResetState,
} from '../../state/reducers/passwordResetReducer';
import { forgotPassword } from '../../state/actions/passwordResetAction';

import { ERROR, LOADING, SUCCESS } from '../../state/dispatchTypes';
import styles from './styles/IdentificationScreen.module.scss';

const ForgotPassword = () => {
  const router = useRouter();
  const [usernameField, setUsernameField] = useState('');

  const [forgotPasswordState, dispatchForgotPassword] = useReducer(
    passwordResetReducer,
    initialPasswordResetState
  );

  const handleSendVerificationCode = () => {
    dispatchForgotPassword({
      type: LOADING,
    });
    const username = `${usernameField}`.replace(/[ +]/g, '');
    const bodyData = {
      username: username,
    };
    forgotPassword(bodyData)
      .then(response => {
        localStorage.resetPasswordData = JSON.stringify(response.data);
        dispatchForgotPassword({
          type: SUCCESS,
        });
        dispatchForgotPassword({ type: 'DEFAULT' });
        router.push('/user/setPassword');
      })
      .catch(error => {
        console.error(error.response, 'error');
        if (error.response.status === 401) {
          dispatchForgotPassword({
            type: ERROR,
            errorMessage: 'User not registered. Check username and try again',
          });
        } else {
          dispatchForgotPassword({
            type: ERROR,
            errorMessage: error.response.data.error_message,
          });
        }
      });
  };

  const handleChange = e => {
    forgotPasswordState.isError && dispatchForgotPassword({ type: 'DEFAULT' });
    setUsernameField(e.target.value);
  };

  return (
    <Fragment>
      <div className={styles.identificationFormWrapper}>
        <div className={styles.phoneInputWrapper}>
          <form className="app-form">
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                autoComplete="username"
                value={usernameField}
                data-testid="username-field"
                onChange={handleChange}
                onKeyDown={e => {
                  if (e.code === 'Enter') {
                    e.preventDefault();
                    if (usernameField !== '') {
                      handleSendVerificationCode();
                    }
                  }
                }}
                placeholder="provide username or phone"
              />
            </div>
          </form>
        </div>
        {forgotPasswordState.isError && (
          <div className="error-section">
            {forgotPasswordState.errorMessage}
          </div>
        )}
        <div className="button">
          <button
            className="custom-button"
            data-testid="submit-button"
            disabled={usernameField === '' || forgotPasswordState.isLoading}
            onClick={handleSendVerificationCode}
          >
            Continue
          </button>
          {forgotPasswordState.isLoading && (
            <CircularProgress size={25} className="button-loader" />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
